<template>
  <section class="resume__nav">
    <router-link
      :id="navItem.title.toLowerCase().replace(/\s/g, '-')"
      v-for="navItem in navItems"
      v-bind:key="navItem.id"
      v-bind:to="navItem.link"
      class="resume__nav__link"
      >{{ navItem.title }}</router-link
    >
    <!-- <router-link @click="navTap" to="/resume/skills" class="resume__nav__link"
      >Skills</router-link
    >

    <router-link
      @hover="navTap"
      to="/resume/workhistory"
      class="resume__nav__link"
      >Work History</router-link
    >

    <router-link @click="navTap" to="/resume/contact" class="resume__nav__link"
      >Contact</router-link
    > -->
  </section>
</template>

<script>
  import { navItems } from "../../data.js"
  import anime from "animejs"
  export default {
    name: "ResumeNav",
    data() {
      return {
        navItems,
      }
    },
    methods: {
      navTap() {
        console.log("yo")
        anime({
          targets: ".resume__nav__link",
          //translateX: ["0", "250"],
          scale: [
            { value: 0.9, duration: 100 },
            { value: 1.1, duration: 200 },
            { value: 0.9, duration: 100 },
            { value: 1, duration: 100 },
          ],
          // keyframes: [
          //   { scale: 1 },
          //   { scale: 1.1 },
          //   { scale: 0.9 },
          //   { scale: 1 },
          // ],
          // duration: 30,
          // easing: "easeOutElastic(1, .8)",
        })
      },
      navSlug() {
        const navSlug = navItem.title
      },
    },
  }
</script>

<style lang="scss">
  @import "./src/scss/style--light";

  .resume__nav {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    border-top: 1px dashed rgba(var(--text-tertiary), 1);
    border-bottom: 1px dashed rgba(var(--text-tertiary), 1);
    background-color: rgba(var(--background-primary), 1);
    position: sticky;
    top: 0;
    background-color: white;
    z-index: 500;
    @media screen and (min-width: 800px) {
      flex-wrap: nowrap;
      justify-content: space-around;
    }
  }

  .resume__nav__link {
    position: relative;
    text-decoration: none;
    text-align: center;
    font-size: 14px;
    width: 30%;
    padding: 1rem 0rem;
    color: rgba(var(--text-tertiary), 1);
    transition: all 0.25s ease-out;
    background-color: rgba(var(--background-primary), 1);
    @media screen and (min-width: 800px) {
      flex-wrap: nowrap;
      width: auto;
    }
    @media screen and (min-width: 531px) {
      width: 20%;
    }
  }

  .resume__nav__link::before {
    content: "";
    width: 14px;
    height: 14px;
    position: relative;
    top: 2px;
    left: -7px;
    display: inline-block;
  }
  .resume__nav__link:hover {
    color: rgba(var(--text-secondary), 1);
    font-weight: 400;
  }

  .router-link-active.resume__nav__link {
    color: rgba(var(--text-secondary), 1);
    font-weight: 900;
    background-color: rgba(var(--background-secondary), 0.3);
  }

  .resume__nav__link::after {
    content: "";
    display: block;
    width: 0;
    height: 3px;
    background-color: rgba(var(--background-secondary), 1);
    position: relative;
    top: 1.1rem;
    transform-origin: 50% 50%;
    margin: 0 auto;
    transition: width 0.3s ease-in-out;
    z-index: 3;
  }

  .resume__nav__link:hover.resume__nav__link::after {
    width: 100%;
    animation: navBounce 0.5s;
  }

  .router-link-active.resume__nav__link::after {
    width: 100%;
  }

  .router-link-active.resume__nav__link::before {
    content: "!!!";
    width: 14px;
    height: 14px;
    position: relative;
    top: 2px;
    left: -7px;
    display: inline-block;
  }

  #about.router-link-active.resume__nav__link::before {
    content: url("/img/icon-solid-about.svg");
  }
  .dark-theme #about.router-link-active.resume__nav__link::before {
    content: url("/img/icon-solid-about--dark.svg");
  }
  #skills.router-link-active.resume__nav__link::before {
    content: url("/img/icon-solid-skills.svg");
  }
  .dark-theme #skills.router-link-active.resume__nav__link::before {
    content: url("/img/icon-solid-skills--dark.svg");
  }
  #work-history.router-link-active.resume__nav__link::before {
    content: url("/img/icon-solid-history.svg");
  }
  .dark-theme #work-history.router-link-active.resume__nav__link::before {
    content: url("/img/icon-solid-history--dark.svg");
  }
  #projects.router-link-active.resume__nav__link::before {
    content: url("/img/icon-solid-projects.svg");
  }
  .dark-theme #projects.router-link-active.resume__nav__link::before {
    content: url("/img/icon-solid-projects--dark.svg");
  }
  #contact.router-link-active.resume__nav__link::before {
    content: url("/img/icon-solid-contact.svg");
  }
  .dark-theme #contact.router-link-active.resume__nav__link::before {
    content: url("/img/icon-solid-contact--dark.svg");
  }

  @keyframes navBounce {
    0% {
      width: 0%;
    }
    90% {
      width: 100%;
    }
    95% {
      width: 90%;
    }
    100% {
      width: 100%;
    }
  }
</style>
